import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useLanguage } from "@/lib/i18n/language-provider"

interface DeleteMireDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  mireName: string
}

export function DeleteMireDialog({
  open,
  onOpenChange,
  onConfirm,
  mireName
}: DeleteMireDialogProps) {
  const { t } = useLanguage()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('synoptic.deleteMireTitle')}</DialogTitle>
          <DialogDescription>
            {t('synoptic.deleteMireDescription', { name: mireName })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('synoptic.cancel') || 'Annuler'}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t('synoptic.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
